import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---------------------------------------------------------------------------
// Admin bearer-token helpers · Option A
// ---------------------------------------------------------------------------
// Any request whose URL starts with /admin or hits a gated /hub read gets the
// Director's admin token attached automatically from localStorage. Pair with
// the backend admin middleware in server.py.
const ADMIN_TOKEN_KEY = "ig_admin_token";
const ADMIN_PROTECTED_PATTERNS = [
    /^\/admin\//,
    /^\/admin$/,
    /^\/hub\/partners$/,
    /^\/hub\/feedback$/,
    /^\/hub\/leads$/,
    /^\/hub\/franchises$/,            // only POST — safe for GET too
    /^\/hub\/cyberops\/seed$/,
];

export function getAdminToken() {
    try { return localStorage.getItem(ADMIN_TOKEN_KEY) || ""; } catch { return ""; }
}
export function setAdminToken(token) {
    try {
        if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
        else localStorage.removeItem(ADMIN_TOKEN_KEY);
    } catch { /* ignore */ }
}
export function clearAdminToken() { setAdminToken(""); }

api.interceptors.request.use((config) => {
    const url = (config.url || "").split("?")[0];
    if (ADMIN_PROTECTED_PATTERNS.some((re) => re.test(url))) {
        const token = getAdminToken();
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

// On 401 for an admin-protected URL, clear the stale token so the page
// re-prompts. (The actual re-prompt UI lives in /pages/Admin.jsx.)
api.interceptors.response.use(
    (res) => res,
    (err) => {
        try {
            const status = err?.response?.status;
            const url = (err?.config?.url || "").split("?")[0];
            if (status === 401 && ADMIN_PROTECTED_PATTERNS.some((re) => re.test(url))) {
                clearAdminToken();
            }
        } catch { /* ignore */ }
        return Promise.reject(err);
    }
);

export async function fetchProducts() {
    const { data } = await api.get("/products");
    return data.products;
}

export async function fetchProduct(slug) {
    const { data } = await api.get(`/products/${slug}`);
    return data;
}

export async function createCheckoutSession(payload) {
    const { data } = await api.post("/checkout/session", payload);
    return data;
}

export async function fetchCheckoutStatus(sessionId) {
    const { data } = await api.get(`/checkout/status/${sessionId}`);
    return data;
}

export async function subscribeNewsletter(email) {
    const { data } = await api.post("/newsletter", { email });
    return data;
}
